/**
 * @ngdoc component
 * @name common.component.contact:contact-chat
 * @description
 * Componente para mostrar la opción de contacto por Chat en la sección contacto
 *
 */
(function () {
    'use strict';

    var ItxContactChatCmp = {
        controller: ItxContactChatCmpCtrl,
        templateUrl: 'contact-chat.component.html',
        bindings: {
            hours: '<'
        }
    };

    ItxContactChatCmpCtrl.$inject = ['ngDialog', 'ItxChatSvc', '$rootScope'];

    function ItxContactChatCmpCtrl(ngDialog, ItxChatSvc, $rootScope) {
        var _this = this;

        _this.showChatBotAccessButton = false;

        _this.$onInit = function () {
            // Mostramos el botón de acceso al chat si está operativo
            if (_this.hours.config.chatOnline) {
                _this.showChatBotAccessButton = true;
            }
        };

        /**
         * Función para abrir el chatbot (por ahora, de tipo Hubtype)
         */
        _this.openChat = function (event) {
            if (!_this.showChatBotAccessButton) {
                event.preventDefault();
            } else {
                ngDialog.close();
                ItxChatSvc.openHubtype();
                const options = {
                    bubbles: true,
                    composed: true
                };
                document.dispatchEvent(new CustomEvent('legacy-event-chat', options));

                $rootScope.$broadcast('changeChatVisualizations', {
                    event: 'hideButton'
                });
            }
        };
    }
    angular.module('itxApp.common').component('itxContactChat', ItxContactChatCmp);
})();
